import { createContext, useContext } from 'react';
import { FeedbackWorkflowContextType } from './types.ts';

export const FeedbackWorkflowContext = createContext<FeedbackWorkflowContextType>({} as FeedbackWorkflowContextType);
export const useFeedbackWorkflow = () => useContext(FeedbackWorkflowContext);